













































import type { PeriodeMetOpdrachten } from "../../types/opdrachten/PeriodeMetOpdrachten";
import type { PeriodeMetOnderbrekingen } from "../../types/opdrachten/PeriodeMetOnderbrekingen";
import type { ChronologieFilterValue } from "./chronologie-filter-value";
import type { TypeFilterValue } from "./type-filter-value";

import Vue from "vue";
import EhrNavigation from "./../interface/EhrNavigation.vue";
import { RepositoryFactory } from "./../repositories/RepositoryFactory.js";
import IsLoading from "./IsLoading.vue";
import PeriodesMetOnderbrekingen from "./PeriodesMetOnderbrekingen.vue";
import PeriodesMetOpdrachten from "./PeriodesMetOpdrachten.vue";
import RadioButton from "./RadioButton.vue";
import EhrIcon from "./EhrIcon.vue";
import { ModuleSettings } from "../repositories/opdrachtRepository";

interface Data {
    moduleSettings: ModuleSettings;
    isLoading: boolean,
    periodesMetOpdrachten: PeriodeMetOpdrachten[],
    periodesMetOnderbrekingen: PeriodeMetOnderbrekingen[],
    chronologieFilter: ChronologieFilterValue,
    typeFilter: TypeFilterValue,
}

const OpdrachtRepository = RepositoryFactory.get("opdracht");

export default Vue.extend({
    name: "OpdrachtenModule",
    components: {
        EhrNavigation,
        RadioButton,
        IsLoading,
        PeriodesMetOpdrachten,
        PeriodesMetOnderbrekingen,
        EhrIcon,
    },
    props: {
        placeholder: {
            type: String,
            required: false,
        },
    },
    data(): Data {
        return {
            isLoading: false,
            moduleSettings: {} as ModuleSettings,
            periodesMetOpdrachten: [] as PeriodeMetOpdrachten[],
            periodesMetOnderbrekingen: [] as PeriodeMetOnderbrekingen[],
            chronologieFilter: 'Heden',
            typeFilter: 'opdrachten'
        };
    },
    computed: {
        filteredPeriodesMetOpdrachten(): PeriodeMetOpdrachten[] {
            return this.chronologieFilter === 'Alle'
                ? this.periodesMetOpdrachten
                : this.periodesMetOpdrachten.filter(({ periode }) => periode.chronologie === this.chronologieFilter)
        },
        filteredPeriodesMetOnderbrekingen(): PeriodeMetOnderbrekingen[] {
            return this.chronologieFilter === 'Alle'
                ? this.periodesMetOnderbrekingen
                : this.periodesMetOnderbrekingen.filter(({ periode }) => periode.chronologie === this.chronologieFilter)
        },
        isChronologieFilterToekomstVisible(): boolean {
          const hasOpdrachtenInToekomst = this.periodesMetOpdrachten.filter(({periode}) => periode.chronologie === "Toekomst").length > 0;
          const hasOnderbrekingenInToekomst = this.periodesMetOnderbrekingen.filter(({periode}) => periode.chronologie === "Toekomst").length > 0;
          return hasOpdrachtenInToekomst || hasOnderbrekingenInToekomst;
        }
    },
    created() {
        this.getData();
    },
    methods: {
        async getData(): Promise<void> {
            this.isLoading = true;
            const [moduleSettings, periodesMetOpdrachten, periodesMetOnderbrekingen] = await Promise.all([
                OpdrachtRepository.moduleSettings(),
                OpdrachtRepository.getPeriodesMetOpdrachten(),
                OpdrachtRepository.getPeriodesMetOnderbrekingen(),
            ]);
            this.moduleSettings = moduleSettings;
            this.periodesMetOpdrachten = periodesMetOpdrachten;
            this.periodesMetOnderbrekingen = periodesMetOnderbrekingen;
            this.isLoading = false;
        },
    },
});
